import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import differenceInDays from 'date-fns/differenceInDays';
import TaskTimeline from './TaskTimeline';
import ProjectTimeline from './ProjectTimeline';
import { Wrap } from './styles';
import sortOnlyOneOfEachProject from '../../../utils/filterTasksOrProjects';
import { getLocalDateTime } from '../../../utils/utils';

const Overview = ({ tasks }) => {
  const [priorityTasks, setpriorityTasks] = useState([]);
  const [priorityProjects, setPriorityProjects] = useState([]);

  const getTopPriorities = ({ arrayOfTasks, isProject }) => {
    if (isProject) {
      const sortTasksByDate = arrayOfTasks
        .map(urgentProject => ({
          ...urgentProject,
          projectName: urgentProject.project.name,
          days: differenceInDays(
            new Date(
              getLocalDateTime(
                urgentProject.project.plannedCompletionDate.split('T')[0],
              ),
            ),
            new Date(new Date()),
          ),
        }))
        .filter(project => project.project.percentComplete < 100)
        .sort((a, b) => a.days - b.days);

      const filterProjectsByName = sortOnlyOneOfEachProject(sortTasksByDate);

      return filterProjectsByName;
    }

    return arrayOfTasks
      .map(urgentTask => ({
        ...urgentTask,
        days: differenceInDays(
          new Date(
            getLocalDateTime(urgentTask.plannedCompletionDate.split('T')[0]),
          ),
          new Date(getLocalDateTime(urgentTask.plannedStartDate.split('T')[0])),
        ),
      }))
      .sort((a, b) => a.days - b.days)
      .slice(0, 5);
  };

  useEffect(() => {
    const incomingTasks = getTopPriorities({ arrayOfTasks: tasks });
    setpriorityTasks(incomingTasks);
  }, [tasks]);

  useEffect(() => {
    const incomingProjects = getTopPriorities({
      arrayOfTasks: tasks,
      isProject: true,
    });
    setPriorityProjects(incomingProjects);
  }, [tasks]);

  return (
    <Wrap>
      {priorityTasks && <TaskTimeline priorityTasks={priorityTasks} />}
      {priorityProjects && (
        <ProjectTimeline priorityProjects={priorityProjects} />
      )}
    </Wrap>
  );
};

Overview.propTypes = {
  tasks: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.string,
      name: PropTypes.string,
      objCode: PropTypes.string,
      percentComplete: PropTypes.number,
      plannedCompletionDate: PropTypes.string,
      plannedStartDate: PropTypes.string,
      progressStatus: PropTypes.string,
      project: PropTypes.shape({
        ID: PropTypes.string,
        name: PropTypes.string,
        objCode: PropTypes.string,
        percentComplete: PropTypes.number,
        plannedCompletionDate: PropTypes.string,
        plannedStartDate: PropTypes.string,
      }),
    }),
  ),
};

Overview.defaultProps = {
  tasks: [],
};

export default Overview;
